var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKebabcontacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Kebab_contacts",
    "data-name": "Kebab contacts",
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 21,
    viewBox: "0 0 5 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2872",
    "data-name": "Group 2872",
    transform: "translate(9 21) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(4)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(4 8)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(4 16)",
    fill: "#a5a5a5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebabcontacts);
export default __webpack_public_path__ + "static/media/Kebab contacts.ff1422646a802caac853db1fe9a69cb2.svg";
export { ForwardRef as ReactComponent };